function bindCurrencyFields() {
	$('input.currency')
		.on('keydown', function(e) {
			// ReSharper disable InconsistentNaming
			var BACKSPACE_KEY = 8,
				DELETE_KEY = 35,
				PERIOD_KEY = 190,
				DECIMAL_KEY = 110,
				COMMA_KEY = 188,
				ANDROID_NUMERIC_KEYBOARD_NON_NUMERIC_KEY = 0;
			// ReSharper restore InconsistentNaming

			if (e.which == BACKSPACE_KEY || e.which == DELETE_KEY) {
				$(this).data('last-value', '');
			} else {
				$(this).data('last-value', this.value);
			}

			// If you type 45.67, The 4 and 5 would first be converted to 0.45 and then adding the '.' would be invalid, so we need to ignore decimals.
			if (e.which == ANDROID_NUMERIC_KEYBOARD_NON_NUMERIC_KEY || e.which == PERIOD_KEY || e.which == DECIMAL_KEY || e.which == COMMA_KEY) {
				e.preventDefault();
				return;
			}
		})
		.on('keyup', function(e) {
			// Remove non-digits and leading zeroes.
			var digits = $(this).val().replace(/\D*/g, '').replace(/^0*/, '');

			// This happens if the type of the input field is number and a comma or other character is entered that makes the input not a number, so the input gets cleared out by the browser.
			if (digits.length == 0 && $(this).data('last-value')) {
				digits = $(this).data('last-value').replace(/\D*/g, '').replace(/^0*/, '');
			}

			if (digits.length == 0) {
				return;
			}

			var pad = "000";

			var padded = pad.substring(0, pad.length - digits.length) + digits;
			var dollars = padded.slice(0, padded.length - 2);
			var cents = padded.slice(-2);

			$(this).val(dollars + '.' + cents);
		});
}

// call when partial panel header is available in DOM
// creates shadow effect for content scrolling underneath header
function partialPanelHeaderScrollEffect() {
	$('.mm-partial-panel').off('scroll.partialpanel').on('scroll.partialpanel', function() {
		var $this = $(this);
		var panelScrollDistance = $this.scrollTop();
		var $panelHeader = $this.find('.panel-header');

		if (panelScrollDistance > 10) {
			$panelHeader.addClass('scrolled');
		} else {
			if ($panelHeader.hasClass('scrolled')) {
				$panelHeader.removeClass('scrolled');
			}
		}
	});
}

function formatAmountInput() {
	var defaultAmountText = $("#amountInput input").attr("placeholder");
	var focusAmountText = "0.00";

	var checkAmountVal = function() {
		if (!$("#amountInput input").val()) {
			$("#amountInput").removeClass("focused");
		}
	};

	// Check if focused class has been applied
	checkAmountVal();

	// Updates placeholder for amount input on focus/blur
	$('#amountInput input').focus(function() {
		$(this).attr("placeholder", focusAmountText);
		$("#amountInput").addClass("focused");
	});

	$('#amountInput input').blur(function() {
		$(this).attr("placeholder", defaultAmountText);
		if (!$(this).val()) {
			$("#amountInput").removeClass("focused");
		}
	});
}
